<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useGeneralStore } from "../../stores/useGeneralStore";
import { usePkSurvey } from "@/stores/usePkSurvey";
import { useStore } from "vuex";
import ApiService from "../../common/service.api";
import MasterLayout from "../../components/MasterLayout.vue";
import axios from "axios";
const vuexStore = useStore();

const pkSurvey = usePkSurvey();

const currentUser = pkSurvey.currentUser;

const startedQuiz = ref(false);
const generalStore = useGeneralStore();
const router = useRouter();
const route = useRoute();
const currentRisposta = ref(null);
const survey = computed(() => generalStore.currentSurvey);
console.log("survey store", survey.value);
const selectedRating = ref(null);
const hoverRating = ref(0);
const currentIndex = ref(0);
const slideDirection = ref("forward"); 
console.log("survey antes", survey.value.risposte);
const progress = computed(() => `${currentIndex.value + 1}/${survey.value.risposte.length}`);
console.log("survey", progress.value);
function startQuiz() {
  startedQuiz.value = true;
console.log("survey adento", survey.value.risposte);
  if (survey.value.risposte.length > 0) {
    currentIndex.value = 0;
    currentRisposta.value = survey.value.risposte[currentIndex.value];
    console.log("currentRisposta.value test", currentRisposta.value);
    selectedRating.value = currentRisposta.value.valore || null;
  }
}

async function saveAndGoToNext() {
  slideDirection.value = "forward";
  console.log("selectedRating.value", selectedRating.value);
  if (selectedRating.value !== null) {
    currentRisposta.value.valore = selectedRating.value;

   
    const updatedSurvey = { ...survey.value };
    console.log("updatedSurvey", updatedSurvey);
    updatedSurvey.risposte[currentIndex.value] = currentRisposta.value;
    pkSurvey.setCurrentSurvey(updatedSurvey);

    if (currentIndex.value < survey.value.risposte.length - 1) {
      currentIndex.value++;
      currentRisposta.value = survey.value.risposte[currentIndex.value];
      selectedRating.value = currentRisposta.value.valore || null;
    } else {
      await completeSurvey();
    }
  }
}

onMounted(async () => {
  try {
    const res = await axios.get('https://api-automotive-demo.whappy.it/api/Survey/Get/19');
    console.log('Survey:', res.data);
  } catch (err) {
    console.error('❗Error getting survey:', err);
  }
});

function goToPrevious() {
  if (currentIndex.value > 0) {
    currentRisposta.value.valore = selectedRating.value;
    slideDirection.value = "backward";
    currentIndex.value--;
    currentRisposta.value = survey.value.risposte[currentIndex.value];
    selectedRating.value = currentRisposta.value.valore || null;
  }
}

async function completeSurvey() {
  router.push("/pk-end-survey/" + route.params.idSurvey);
}

function handleRatingClick(rating) {
  console.log("handleRatingClick", rating);
  console.log('cuurent risponse', currentRisposta.value);
  if (currentRisposta.value.data_risposta || isSurveyCompleteOrDeleted())
    return;
  selectedRating.value = rating;
}

function handleHover(rating) {
  hoverRating.value = rating;
}

function handleMouseLeave() {
  hoverRating.value = 0;
}

function isSurveyCompleteOrDeleted() {
  return survey.value.completato || survey.value.eliminato;
}

async function getSurveyById(idSurvey) {
  try {
    const result = await ApiService.get();
    return result.data;
  } catch (err) {
    console.error(err);
  }
}

onMounted(async () => {
  if (!currentUser) {
    pkSurvey.setCurrentUser(vuexStore.state.user.userData);
  }

  if (route.params.idSurvey == 19) {
    generalStore.setCurrentSurvey({
      id: 715,
      id_survey: 19,
      id_user_survey: 715,
      id_utente_valutato: 241,
      id_utente_valutatore: 229,
      inizio: "2024-10-30T17:46:35.077",
      fine: "2024-11-09T17:46:35.077",
      eliminato: false,
      completato: null,
      nome: null,
      t_nome: {
        "it-IT": "Survey Onboarding primo mese",
        "en-EN": "",
        "es-ES": "",
        "de-DE": "",
        "fr-FR": "",
        "ml-ML": "",
        "cn-CN": "",
      },

    });
  }

  if (route.params.idSurvey && !generalStore.currentSurvey) {
    const response = await getSurveyById(route.params.idSurvey);
    generalStore.setCurrentSurvey(response);
  }

startQuiz();
});
</script>

<template>
  <master-layout :showBack="true" smallTitle="il tuo" bigTitle="Questionario">
    <div
      class="flex flex-column justify-content-between align-items-stretch"
      style="height: calc(100vh - 150px)"
    >
      <div class="pb-4 mb-4">
        <div
          class="w-full flex flex-column justify-content-center align-items-center p-4"
        >
        <div class="progress-indicator">
  {{ progress }}
</div>
          <div>
            <img
              :src="currentUser.image || currentUser.avatar_url"
              style="width: 6rem; height: 6rem; border-radius: 50%"
            />
          </div>

          <div class="name font-bold text-18">
            <span>{{
              currentUser.name || currentUser.nome + " " + currentUser.cognome
            }}</span>
          </div>

          <div class="role">
            <span>{{ currentUser.role }}</span>
          </div>
        </div>
        <transition
          :name="
            slideDirection === 'forward' ? 'slide-forward' : 'slide-backward'
          "
          mode="out-in"
        >
          <div :key="currentIndex" class="page-container">
            <div class="main-image">
              <img src="../../../public/assets/img/yellowStar.png" />
            </div>
            <h4 class="text-16 mt-4 mb-2" style="color: white">
              aca<pre>{{ currentRisposta?.domanda }}</pre>
              {{
                startedQuiz ? currentRisposta?.domanda?.t_domanda["it-IT"] : ""
              }}
            </h4>

            <div class="rating-container">
              <div
                v-for="x in 5"
                :key="x"
                @click="handleRatingClick(x)"
                @mouseover="handleHover(x)"
                @mouseleave="handleMouseLeave"
                style="cursor: pointer"
              >
                <img
                  :src="
                    x <= hoverRating || x <= selectedRating
                      ? '/assets/img/fullStar.png'
                      : '/assets/img/emptyStarLight.png'
                  "
                  style="margin-left: 0.3rem; margin-right: 0.3rem"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="footer-container">
        <div class="button-container">
          <button
            class="w-full button-secondary p-d mr-2 text-18"
            @click="goToPrevious"
            :disabled="currentIndex === 0"
          >
            Previous
          </button>
          <button
            class="w-full button-primary p-d ml-4 text-18"
            @click="saveAndGoToNext"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  margin-top: 32px;
  background-color: var(--ion-color-primary);
  border-radius: 10px;
  color: var(--text-color-light);
}

.rating-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 1rem;
  /* background-color: rgb(202, 202, 202); */
  padding: 0.3rem;
  border-radius: var(--ion-border-radius);
}

.rating-container img {
  transition: transform 0.2s ease-in-out;
}

.rating-container img:hover {
  transform: scale(1.2);
}

/* Bottoni "Next" e "Previous" */
.button-container {
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.arrow {
  margin-left: 0.5rem;
  font-size: 1.2rem;
}

/* Animazioni sliding */
.slide-forward-enter-active,
.slide-forward-leave-active,
.slide-backward-enter-active,
.slide-backward-leave-active {
  transition: all 0.5s ease;
}

.slide-forward-enter,
.slide-backward-leave-to {
  transform: translateX(150%);
}

.slide-forward-leave-to,
.slide-backward-enter {
  transform: translateX(-150%);
}
.progress-indicator {
  font-size: 1.2rem;
  font-weight: bold;
  color:black;
  margin-bottom: 1rem;
}
</style>
